(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["family-bundles"] && !Shopify.designMode) return;
  try {
    
  /* Family bundles: pick a size and quantity per family member, see the tiered saving live,
     add every piece to the bag in one request. The real discount is applied by Shopify's
     automatic discounts; this preview mirrors the tiers set on the section. */
  class FamilyBundles extends HTMLElement {
    connectedCallback() {
      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]').sort((a, b) => a.quantity - b.quantity);
      } catch (error) {
        this.tiers = [];
      }
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[data-family-panel]'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          const next = (i + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
      this.panels.forEach((panel) => {
        panel.querySelectorAll('[data-family-role]').forEach((role) => {
          role.querySelectorAll('[data-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(role, Number(button.dataset.step), panel));
          });
          role.querySelector('[data-family-variant]').addEventListener('change', () => this.update(panel));
        });
        panel.querySelector('[data-family-add]').addEventListener('click', () => this.add(panel));
        this.update(panel);
      });
      this.setAttribute('data-ready', '');
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => panel.toggleAttribute('data-inactive', i !== index));
      this.update(this.panels[index]);
    }

    step(role, delta, panel) {
      const output = role.querySelector('[data-count]');
      const count = Math.min(9, Math.max(0, Number(output.textContent) + delta));
      output.textContent = String(count);
      role.querySelector('[data-step="-1"]').disabled = count === 0;
      role.classList.toggle('is-picked', count > 0);
      this.update(panel);
    }

    lines(panel) {
      return Array.from(panel.querySelectorAll('[data-family-role]')).map((role) => {
        const select = role.querySelector('[data-family-variant]');
        const option = select.options[select.selectedIndex];
        return { id: Number(select.value), price: Number(option.dataset.price), quantity: Number(role.querySelector('[data-count]').textContent) };
      }).filter((line) => line.quantity > 0 && line.id);
    }

    tierFor(count) {
      return this.tiers.filter((tier) => count >= tier.quantity).pop() || null;
    }

    update(panel) {
      const lines = this.lines(panel);
      const count = lines.reduce((sum, line) => sum + line.quantity, 0);
      const subtotal = lines.reduce((sum, line) => sum + line.price * line.quantity, 0);
      const tier = this.tierFor(count);
      const total = tier ? Math.round(subtotal * (1 - tier.percent / 100)) : subtotal;
      const money = (cents) => (window.theme ? window.theme.formatMoney(cents) : `$${(cents / 100).toFixed(2)}`);
      const d = this.dataset;

      panel.querySelector('[data-summary-count]').textContent = count === 0 ? d.labelEmpty : (count === 1 ? d.labelCountOne : d.labelCountOther).replace('__COUNT__', count);
      const subtotalEl = panel.querySelector('[data-summary-subtotal]');
      subtotalEl.hidden = !tier;
      subtotalEl.textContent = tier ? money(subtotal) : '';
      panel.querySelector('[data-summary-total]').textContent = count ? money(total) : '';

      const next = this.tiers.find((t) => t.quantity > count);
      let nudge = '';
      if (next) nudge = d.labelNudge.replace('__COUNT__', next.quantity - count).replace('__PERCENT__', next.percent);
      else if (tier) nudge = d.labelBest.replace('__PERCENT__', tier.percent);
      if (tier && subtotal > total) nudge = `${d.labelSaving.replace('__AMOUNT__', money(subtotal - total))}. ${nudge}`;
      panel.querySelector('[data-summary-nudge]').textContent = nudge;
      panel.querySelector('[data-family-add]').disabled = count === 0;
      panel.querySelector('.family-bundles__summary').classList.toggle('is-active', count > 0);
    }

    async add(panel) {
      const button = panel.querySelector('[data-family-add]');
      const error = panel.querySelector('[data-family-error]');
      const items = this.lines(panel).map(({ id, quantity }) => ({ id, quantity }));
      if (!items.length) return;
      button.classList.add('is-loading');
      button.disabled = true;
      error.hidden = true;
      try {
        const routes = window.routes || {};
        const response = await fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname }),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || '');
        if (window.themeSettings && window.themeSettings.cartType === 'page') {
          window.location.href = routes.cart_url || '/cart';
          return;
        }
        const cart = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'family-bundles', sections: data.sections, open: true } }));
      } catch (err) {
        error.textContent = err.message || (window.themeStrings && window.themeStrings.cartError) || 'Something went wrong.';
        error.hidden = false;
      } finally {
        button.classList.remove('is-loading');
        button.disabled = this.lines(panel).length === 0;
      }
    }
  }

  if (!customElements.get('family-bundles')) customElements.define('family-bundles', FamilyBundles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  /* Footer logo reveal: draws the monogram, grows the divider, wipes in LUMI then THREADS, once. */
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const arm = (scope = document) => {
      const logo = scope.querySelector('.site-footer__logo');
      if (!logo || reduce.matches || !('IntersectionObserver' in window)) return;
      logo.classList.remove('is-revealed');
      logo.querySelectorAll('svg g path').forEach((path) => path.setAttribute('pathLength', '1'));
      // Apply the hidden starting state instantly, then re-enable transitions for the reveal.
      logo.classList.add('is-arming', 'is-armed');
      logo.getBoundingClientRect();
      requestAnimationFrame(() => logo.classList.remove('is-arming'));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(() => logo.classList.add('is-revealed'));
          observer.disconnect();
        });
      }, { threshold: 0.35 });
      observer.observe(logo);
    };
    arm();
    document.addEventListener('shopify:section:load', (event) => arm(event.target));
  })();

  /* Scale the footer wordmark so the store name spans the page exactly, whatever its length. */
  (() => {
    const fit = () => {
      document.querySelectorAll('[data-fit-text]').forEach((el) => {
        const box = el.parentElement;
        const style = getComputedStyle(box);
        const available = box.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
        el.style.fontSize = '100px';
        let width = el.getBoundingClientRect().width;
        if (!width) return;
        let size = Math.floor((100 * available) / width);
        el.style.fontSize = `${size}px`;
        // Second pass: kerning and tracking do not scale perfectly, so correct any leftover overflow.
        width = el.getBoundingClientRect().width;
        if (width > available) el.style.fontSize = `${Math.floor((size * available) / width)}px`;
      });
    };
    let frame;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    if (document.fonts) {
      document.fonts.ready.then(schedule);
      document.fonts.addEventListener('loadingdone', schedule);
    }
    schedule();
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-hero-video-toggle]');
      if (!this.video || !this.toggle) return;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduce.matches) this.video.pause();
      this.sync = this.sync.bind(this);
      this.video.addEventListener('play', this.sync);
      this.video.addEventListener('pause', this.sync);
      this.toggle.addEventListener('click', () => {
        if (this.video.paused) this.video.play().catch(() => {});
        else this.video.pause();
      });
      this.sync();
    }

    sync() {
      const paused = this.video.paused;
      this.toggle.classList.toggle('is-paused', paused);
      this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
    }
  }

  if (!customElements.get('hero-video')) customElements.define('hero-video', HeroVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  class LookbookHotspots extends HTMLElement {
    connectedCallback() {
      this.hotspots = Array.from(this.querySelectorAll('details'));
      this.hotspots.forEach((spot) => {
        spot.addEventListener('toggle', () => {
          if (!spot.open) return;
          this.hotspots.forEach((other) => {
            if (other !== spot) other.open = false;
          });
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = this.hotspots.find((spot) => spot.open);
        if (!open) return;
        open.open = false;
        open.querySelector('summary').focus();
      });
      this.onDocumentClick = (event) => {
        if (event.target.closest && event.target.closest('details') && this.contains(event.target)) return;
        this.hotspots.forEach((spot) => {
          spot.open = false;
        });
      };
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }
  }

  if (!customElements.get('lookbook-hotspots')) customElements.define('lookbook-hotspots', LookbookHotspots);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  function syncProvinces(country, useDefault) {
    const province = document.getElementById(country.dataset.provinceTarget);
    if (!province) return;
    const field = province.closest('[data-province-field]');
    const option = country.options[country.selectedIndex];
    let provinces = [];
    try {
      provinces = JSON.parse((option && option.dataset.provinces) || '[]');
    } catch (error) {
      provinces = [];
    }
    province.innerHTML = '';
    provinces.forEach(([value, label]) => province.add(new Option(label, value)));
    if (useDefault && province.dataset.default) province.value = province.dataset.default;
    if (field) field.hidden = provinces.length === 0;
  }

  function initAddressForms() {
    document.querySelectorAll('[data-address-country]').forEach((country) => {
      const initial = country.dataset.default;
      if (initial && Array.from(country.options).some((option) => option.value === initial)) {
        country.value = initial;
      }
      syncProvinces(country, true);
      country.addEventListener('change', () => syncProvinces(country, false));
    });

    document.querySelectorAll('form[data-confirm]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!window.confirm(form.dataset.confirm)) event.preventDefault();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAddressForms);
  } else {
    initAddressForms();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  class CopyLink extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const status = this.querySelector('[data-copy-status]');
      if (!button || !navigator.clipboard) return;
      this.hidden = false;
      button.addEventListener('click', () => {
        navigator.clipboard.writeText(this.dataset.copy).then(() => {
          if (!status) return;
          status.textContent = this.dataset.copied;
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            status.textContent = '';
          }, 2500);
        });
      });
    }
  }

  if (!customElements.get('copy-link')) customElements.define('copy-link', CopyLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
  function initPasswordDialog() {
    const passwordDialog = document.getElementById('PasswordDialog');
    if (passwordDialog && typeof passwordDialog.showModal === 'function') {
      const openers = document.querySelectorAll('[data-password-open]');
      const supportsCommands = 'command' in HTMLButtonElement.prototype;
      const setExpanded = (value) => openers.forEach((el) => el.setAttribute('aria-expanded', String(value)));

      openers.forEach((el) => {
        el.addEventListener('click', () => {
          if (!supportsCommands && !passwordDialog.open) passwordDialog.showModal();
          // The invoker command opens the dialog after click handlers run.
          setTimeout(() => setExpanded(passwordDialog.open));
        });
      });

      if (!supportsCommands) {
        passwordDialog.querySelectorAll('[data-dialog-close]').forEach((el) => {
          el.addEventListener('click', () => passwordDialog.close());
        });
      }

      passwordDialog.addEventListener('toggle', () => setExpanded(passwordDialog.open));
      passwordDialog.addEventListener('close', () => setExpanded(false));
      passwordDialog.addEventListener('click', (event) => {
        if (event.target === passwordDialog) passwordDialog.close();
      });

      if (passwordDialog.hasAttribute('data-open-on-load')) {
        passwordDialog.close();
        passwordDialog.showModal();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPasswordDialog);
  } else {
    initPasswordDialog();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('variant:change', (event) => {
    const { sectionId, variant } = event.detail || {};
    const line = document.getElementById(`Stock-${sectionId}`);
    if (!line) return;
    let levels = {};
    try {
      levels = JSON.parse(document.querySelector(`[data-stock-levels="${sectionId}"]`)?.textContent || '{}');
    } catch (error) {
      levels = {};
    }
    const threshold = Number(line.dataset.threshold) || 5;
    const level = variant ? levels[variant.id] : null;
    let state = 'in';
    let label = line.dataset.labelIn;
    if (!variant || !variant.available) {
      state = 'out';
      label = line.dataset.labelOut;
    } else if (level && level.tracked && level.q > 0 && level.q <= threshold) {
      state = 'low';
      label = (level.q === 1 ? line.dataset.labelLowOne : line.dataset.labelLow).replace('__COUNT__', level.q);
    }
    line.innerHTML = '';
    const span = document.createElement('span');
    span.className = `stock-status stock-status--${state}`;
    span.dataset.stockState = state;
    span.textContent = label;
    line.appendChild(span);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sale-popup')) return;

    const STORE_KEY = 'lumi-sale-popup';
    const read = () => {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
    };
    const write = (patch) => {
      try { localStorage.setItem(STORE_KEY, JSON.stringify({ ...read(), ...patch })); } catch (e) { /* storage blocked */ }
    };
    // True on the page a shopper lands on from a paid ad click. Later pages lose the parameters.
    const fromAd = () => {
      const p = new URLSearchParams(location.search);
      const source = (p.get('utm_source') || '').toLowerCase();
      const medium = (p.get('utm_medium') || '').toLowerCase();
      return ['fbclid', 'gclid', 'ttclid', 'msclkid'].some((k) => p.has(k))
        || /^(facebook|fb|instagram|ig|meta|tiktok|pinterest)$/.test(source)
        || /^(cpc|ppc|paid|paid_social|paidsocial|ad|ads|display)$/.test(medium);
    };

    class SalePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.end = this.parseEnd();
        this.units = (this.dataset.units || 'd,h,m,s').split(',');
        this.querySelectorAll('[data-sale-popup-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.querySelector('[data-sale-popup-shop]')?.addEventListener('click', () => write({ dismissedAt: Date.now() }));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
        this.dialog.addEventListener('close', () => {
          this.stopClock();
          if (this.remember && !this.hasAttribute('data-design-mode')) write({ dismissedAt: Date.now() });
        });

        if (this.end && this.end <= Date.now()) return;

        // These markers only render on the page Shopify returns after this form was submitted.
        const posted = this.querySelector('[data-sale-popup-result]');
        if (this.querySelector('[data-sale-popup-result="joined"]') && posted) write({ joined: true });
        if (posted) { this.open(); return; }

        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', (e) => { if (this.closest('.shopify-section')?.id === `shopify-section-${e.detail.sectionId}`) this.open(); });
          document.addEventListener('shopify:section:deselect', () => this.close(false));
          return;
        }

        const state = read();
        const snooze = Number(this.dataset.snoozeDays || 3) * 864e5;
        if (state.joined || (state.dismissedAt && Date.now() - state.dismissedAt < snooze)) return;
        this.arm();
      }

      parseEnd() {
        const date = this.dataset.endDate;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '')) return null;
        const time = /^([01]\d|2[0-3]):[0-5]\d$/.test(this.dataset.endTime || '') ? this.dataset.endTime : '23:59';
        const offset = /^[+-]\d{2}:\d{2}$/.test(this.dataset.tzOffset || '') ? this.dataset.tzOffset : 'Z';
        const ms = Date.parse(`${date}T${time}:59${offset}`);
        return Number.isNaN(ms) ? null : ms;
      }

      arm() {
        let cleanup = () => {};
        const trigger = () => { cleanup(); this.open(); };
        const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
        const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) trigger(); };
        if (fine) document.addEventListener('mouseout', onLeave);
        // Ad visitors see the product first: only exit intent on desktop, nothing on touch screens.
        if (this.hasAttribute('data-hold-for-ads') && fromAd()) {
          cleanup = () => document.removeEventListener('mouseout', onLeave);
          return;
        }
        const onScroll = () => {
          const max = document.documentElement.scrollHeight - innerHeight;
          if (max > 0 && scrollY / max >= 0.5) trigger();
        };
        const timer = setTimeout(trigger, Number(this.dataset.delay || 6) * 1000);
        addEventListener('scroll', onScroll, { passive: true });
        cleanup = () => {
          clearTimeout(timer);
          removeEventListener('scroll', onScroll);
          document.removeEventListener('mouseout', onLeave);
        };
      }

      open() {
        if (this.dialog.open || document.querySelector('dialog[open]:not(.sale-popup__dialog)')) return;
        this.remember = true;
        this.startClock();
        this.dialog.showModal();
        this.animateIn();
      }

      close(remember = true) {
        this.remember = remember;
        if (this.dialog.open) this.dialog.close();
      }

      animateIn() {
        const gsap = window.gsap;
        if (!gsap || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const card = this.querySelector('.sale-popup__card');
        const cat = this.querySelector('.sale-popup__character');
        const tl = gsap.timeline();
        tl.fromTo(card, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.5, ease: 'power3.out', clearProps: 'transform,opacity' });
        if (cat) tl.fromTo(cat, { y: 46, opacity: 0, rotate: -8 }, { y: 0, opacity: 1, rotate: 0, duration: 0.7, ease: 'back.out(2.2)', clearProps: 'transform,opacity' }, '-=0.2');
      }

      startClock() {
        const wrap = this.querySelector('[data-sale-popup-countdown]');
        const out = this.querySelector('[data-sale-popup-time]');
        if (!wrap || !out || !this.end) return;
        const pad = (n) => String(n).padStart(2, '0');
        const [d, h, m, s] = this.units;
        const tick = () => {
          const left = Math.max(0, this.end - Date.now());
          if (left === 0) { this.close(false); return; }
          const days = Math.floor(left / 864e5);
          const hours = Math.floor((left % 864e5) / 36e5);
          const mins = Math.floor((left % 36e5) / 6e4);
          const secs = Math.floor((left % 6e4) / 1e3);
          out.textContent = `${days > 0 ? `${days}${d} ` : ''}${pad(hours)}${h} ${pad(mins)}${m} ${pad(secs)}${s}`;
        };
        tick();
        wrap.hidden = false;
        this.clock = setInterval(tick, 1000);
      }

      stopClock() {
        clearInterval(this.clock);
      }
    }

    customElements.define('sale-popup', SalePopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
